var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"errorTips"},[_vm._v(_vm._s(_vm.loginErrorMsg))]),_vm._v(" "),_c('div',{on:{"click":_vm.back}},[_c('img',{staticClass:"turn",staticStyle:{"position":"fixed","left":"0px","top":"0px","width":"80px","height":"80px","z-index":"9999"},attrs:{"src":require("../assets/back4.png"),"id":"musicStopIco"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce879e62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/LoginError.vue
// module id = null
// module chunks = 